import { createModelSegment } from 'client/data/luckdragon/segment';
import { parseContent } from 'client/data/cms/content';
import { CmsModel } from './cms';

const CPO_CONTENT_PATH = 'cpo-cars-page-content-v2';

export function getCpoPath() {
  return CPO_CONTENT_PATH;
}

export function getCpoContentPath() {
  return `content["${CPO_CONTENT_PATH}"]`;
}

function getMetadataValue(entry, key) {
  return entry && entry.hasMetadata && entry.hasMetadata(key) ? entry.metadata(key).value() : null;
}

function transformFeaturedSpotlightAds(content) {
  return content.map(child => ({
    logo: getMetadataValue(child, 'logo'),
    headline: getMetadataValue(child, 'headline'),
    url: getMetadataValue(child, 'url'),
    urlText: getMetadataValue(child, 'urlText'),
    urlMobile: getMetadataValue(child, 'urlMobile'),
    oemLink: getMetadataValue(child, 'oemLink'),
    urlTargetNew: getMetadataValue(child, 'urlTargetNew'),
    image: getMetadataValue(child, 'image'),
    contentLabel: getMetadataValue(child, 'contentLabel'),
    adLabel: getMetadataValue(child, 'adLabel'),
    disclaimer: getMetadataValue(child, 'disclaimer'),
  }));
}

export const CpoModel = createModelSegment('cpo', [
  {
    path: 'inventoryLogo',
    resolve(match, context) {
      return context
        .resolveValue(getCpoContentPath(), CmsModel)
        .then(content => {
          const inventoryLogoContent = parseContent(content).child('shop-cpo-inventory-logo');
          const inventoryLogoImage = getMetadataValue(inventoryLogoContent, 'image');
          const inventoryLogoUrl = getMetadataValue(inventoryLogoContent, 'url');

          return {
            image: inventoryLogoImage,
            url: inventoryLogoUrl,
          };
        })
        .catch(() => null);
    },
  },
  {
    path: 'carsForSale',
    resolve(match, context) {
      return context
        .resolveValue(getCpoContentPath(), CmsModel)
        .then(content => {
          const carsForSaleContent = parseContent(content).child('cpo-cars-for-sale');
          const makeList = getMetadataValue(carsForSaleContent, 'makeList');
          const modelList = getMetadataValue(carsForSaleContent, 'modelList');

          return {
            makeList: JSON.parse(makeList),
            modelList: JSON.parse(modelList),
          };
        })
        .catch(() => null);
    },
  },
  {
    path: 'featuredSpotlightAd',
    resolve(match, context) {
      return context
        .resolveValue(getCpoContentPath(), CmsModel)
        .then(content => {
          const featuredSpotlightContent = parseContent(content).child('featured-spotlight-carousel');
          const featuredSpotlightContentArray = featuredSpotlightContent.children().length
            ? featuredSpotlightContent.children()
            : [];

          return transformFeaturedSpotlightAds(featuredSpotlightContentArray);
        })
        .catch(() => null);
    },
  },
]);
